module.exports = __webpack_public_path__ + "img/hvac-mechanical-maintenance-05-square.c8399b0f.jpg";